import { Page } from 'components/layout';
import BackgroundImage from 'img/background-image.svg';
import FuturaSection from './FuturaSection';
import GenesisEnigmaSection from './GenesisEnigmaSection';
// import EBArtistSection from './EBArtistSection';
import EulerClubSection from './EulerClubSection';
import RemixStudioSection from './RemixStudioSection';
import { remixEnabled } from 'utils/config';

const LandingPage = () => {
  return (
    <Page title="Home" backgroundImage={`url(${BackgroundImage})`} padding="0" fixedFooter={false}>
      {remixEnabled && <RemixStudioSection />}
      <FuturaSection />
      <GenesisEnigmaSection />
      {/* <EBArtistSection /> */}
      <EulerClubSection />
    </Page>
  );
};

export default LandingPage;
